<template>
  <app-content class="h-panel">
    <div class="h-panel-bar">
      <span class="h-panel-title"><template v-if="auxiliary">{{auxiliary.name}} -</template> 核算项目余额</span>
    </div>
    <Row type="flex" :space-x="10" class="margin-right-left margin-top">
      <Cell>
        <account-date-choose v-model="accountDate"/>
      </Cell>
      <Cell class="label">辅助类别：</Cell>
      <Cell>
        <Select type="object" v-model="auxiliary" :deletable="false" style="min-width: 100px" :datas="auxiliaryType" keyName="id" titleName="name"/>
      </Cell>
      <Cell>
        <Button :disabled="!auxiliary" :loading="loading" color="primary" @click="doSearch">查询</Button>
      </Cell>
      <Cell :flex="1">
        <!--<div class="float-right">
          <Checkbox v-model="showNumPrice">显示数量金额</Checkbox>
        </div>-->
      </Cell>
    </Row>
    <div class="h-panel-body">
      <!-- 外层容器：添加position: relative（为表头sticky提供参考），保留原滚动样式 -->
      <div style="max-height: 670px; overflow-y: auto; width: 100%; position: relative;" v-if="auxiliary">
        <table class="balance" style="border-collapse: separate; border-spacing: 0; table-layout: fixed; width: 100%;">
          <!-- 表头固定：保留原始样式，优化sticky定位层级 -->
          <thead class="header" style="position: sticky; top: 0; z-index: 10; background: #F5F5F5;">
          <tr>
            <td rowspan="2" width="120">{{auxName}}编码</td>
            <td rowspan="2" width="200">{{auxName}}名称</td>
            <td colspan="2" width="200">期初余额</td>
            <td colspan="2" width="200">本期发生额</td>
            <td colspan="2" width="200">期末余额</td>
          </tr>
          <tr>
            <td width="100">借方</td>
            <td width="100">贷方</td>
            <td width="100">借方</td>
            <td width="100">贷方</td>
            <td width="100">借方</td>
            <td width="100">贷方</td>
          </tr>
          </thead>
          <tbody>
          <tr v-for="item in dataList" :key="item.id"> <!-- 修复key绑定（原item.subjecId可能不存在） -->
            <td :style="{'padding-left':(item.level)*10+'px'}" class="nowrap">{{item.code}}</td>
            <td :style="{'padding-left':(item.level)*10+'px'}" class="nowrap"><span class="text-hover">{{item.name}}</span></td>
            <td class="text-right">{{item.beg0inningDebitBalance|numFormat}}</td>
            <td class="text-right">{{item.beginningCreditBalance|numFormat}}</td>
            <td class="text-right">{{item.currentDebitAmount|numFormat}}</td>
            <td class="text-right">{{item.currentCreditAmount|numFormat}}</td>
            <td class="text-right" :class="{tip:item.endingDebitBalance<0}">{{item.endingDebitBalance|numFormat}}</td>
            <td class="text-right" :class="{tip:item.currentCreditAmount<0}">{{item.endingCreditBalance|numFormat}}</td>
          </tr>
          <tr v-if="!dataList.length">
            <td colspan="8" class="text-center padding">暂无数据</td>
          </tr>
          </tbody>
        </table>
      </div>
    </div>
  </app-content>
</template>

<script>
export default {
  name: "AuxiliaryAccountingBalance",
  data() {
    return {
      dataList: [],
      showNumPrice: false,
      loading: false,
      accountDate: null,
      auxiliary: null,
      auxiliaryItem: {},
      auxiliaryType: [],
      auxiliaryList: [],
      auxName: null,
    }
  },
  watch: {
    accountDate() {
      this.loadAuxiliaryType();
    }
  },
  methods: {
    loadAuxiliaryType() {
      this.$api.setting.accountingCategory.list().then(({data}) => {
        this.auxiliaryType = data;
        if (data.length) {
          this.auxiliary = data[0];
          this.auxName = this.auxiliary.name;
          this.loadList();
        }
      });
    },
    loadList() {
      if (this.auxiliary && this.accountDate) { // 补充accountDate校验，避免无日期时请求
        this.loading = true;
        this.$api.accountbook.loadAuxiliaryBalance({
          accountDate: this.accountDate,
          auxiliaryId: this.auxiliary.id
        }).then(({data}) => {
          this.auxName = this.auxiliary.name;
          this.dataList = data;
        }).finally(() => {
          this.loading = false;
        });
      }
    },
    doSearch() {
      this.loadList();
    }
  },
  created() {
    this.loadAuxiliaryType();
  }
}
</script>

<style scoped lang="less">
/* 完全保留原始样式，未做任何修改 */
.balance {
  width: 100%;
  /* 表格外层添加统一边框，替代单元格边框拼接，避免双重边框 */
  border: 1px solid #e2e2e2;
  border-bottom: none;
  border-right: none;

  td {
    padding: 0 8px;
    /* 仅保留单元格的右侧和底部边框，与表格外层边框拼接 */
    border-right: 1px solid #e2e2e2;
    border-bottom: 1px solid #e2e2e2;
    border-top: none;
    border-left: none;
    font-size: 12px;
    height: 35px;

    &.tip {
      background-color: #FFEEEF;
    }
  }

  tbody tr:nth-child(even) {
    background-color: #f8fbf8;
  }

  tbody tr:hover {
    background-color: #F0F6FF;
  }

  .header {
    td {
      background-color: #F5F5F5;
      text-align: center;
      font-weight: bold;
    }
  }
}

/* 补充辅助样式，确保内容不换行、对齐一致 */
.nowrap {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.text-right {
  text-align: right;
}

.text-center {
  text-align: center;
}

.padding {
  padding: 10px 0;
}
</style>